import axios from 'axios';
import { hasAnalyticsConsent } from './consent';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || (window.location.hostname === 'localhost' ? 'http://localhost:8000' : '');
const VISITOR_KEY = 'leion_visitor_id';
const SESSION_KEY = 'leion_session_id';
const SESSION_STARTED_KEY = 'leion_session_started_at';
const SESSION_TTL_MS = 30 * 60 * 1000;

const getId = (key) => {
  let value = window.localStorage.getItem(key);
  if (!value) {
    value = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    window.localStorage.setItem(key, value);
  }
  return value;
};

const getSessionId = () => {
  const startedAt = Number(window.sessionStorage.getItem(SESSION_STARTED_KEY) || 0);
  let value = window.sessionStorage.getItem(SESSION_KEY);
  const isExpired = !startedAt || Date.now() - startedAt > SESSION_TTL_MS;

  if (!value || isExpired) {
    value = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    window.sessionStorage.setItem(SESSION_KEY, value);
    window.sessionStorage.setItem(SESSION_STARTED_KEY, String(Date.now()));
  }
  return value;
};

const getDevice = () => {
  const width = window.innerWidth;
  if (width < 640) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
};

export const trackEvent = (eventType, payload = {}) => {
  if (typeof window === 'undefined') return;
  if (!hasAnalyticsConsent()) return;

  const event = {
    event_type: eventType,
    path: window.location.pathname,
    visitor_id: getId(VISITOR_KEY),
    session_id: getSessionId(),
    referrer: document.referrer || '',
    device: getDevice(),
    ...payload,
  };

  const body = JSON.stringify(event);
  const url = `${BACKEND_URL}/api/analytics/event`;

  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' });
    navigator.sendBeacon(url, blob);
    return;
  }

  axios.post(url, event).catch(() => {});
};

export const fetchAnalyticsSummary = async (days = 30) => {
  const token = window.localStorage.getItem('leion_analytics_token') || '';
  const response = await axios.get(`${BACKEND_URL}/api/analytics/summary`, {
    params: { days },
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return response.data;
};
